import React, { useState } from 'react'

import { BaseContent, Button, ModalBox } from '@fourthwall/components'

type UnsavedChangesModalProps = {
  onSave: () => Promise<void>
  onDiscard: () => void
  onClose: () => void
}

export const UnsavedChangesModal = ({ onSave, onDiscard, onClose }: UnsavedChangesModalProps) => {
  const [loading, setLoading] = useState(false)

  return (
    <ModalBox
      title="Would you like to save your changes?"
      buttons={[
        <Button label="Cancel" disabled={loading} onClick={onClose} />,
        <Button
          label="Discard changes"
          appearance="destructive"
          disabled={loading}
          onClick={() => {
            onDiscard()
            onClose()
          }}
        />,
        <Button
          label="Save changes"
          appearance="primary"
          loading={loading}
          onClick={async () => {
            setLoading(true)
            await onSave()
            setLoading(false)
            onClose()
          }}
        />,
      ]}
      onClose={onClose}
    >
      <BaseContent>
        <p>If you leave this page, all unsaved changes will be discarded.</p>
      </BaseContent>
    </ModalBox>
  )
}
